import React from 'react'
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import Select from '@mui/material/Select';
import { useDispatch, useSelector } from 'react-redux'

import AltaPrestamoEm from './Deduccion/AltaPrestamoEm';

const AltaDeduccion = (props) => {
  const dispatch = useDispatch()
  const [tipo, setTipo] = React.useState('');

  const { lote } = props
  const { periodo } = props
  const { idempleado } = props
  const { activarbotontab } = props
  const { notificacion } = props
  
  const { datotodoempleado } = props
  const {obtenerdatolote} = props

  const deduccion = useSelector(store => store.menus.deducciones)


  const handleChange = (event) => {
    setTipo(event.target.value);
  };


  return (
    <>
      <FormControl fullWidth size="small">
        <InputLabel id="demo-simple-select-label">Tipo</InputLabel>
        <Select
          labelId="demo-simple-select-label"
          id="demo-simple-select"
          value={tipo}
          label="Tipo"
          onChange={handleChange}
        >
          {
            deduccion.map((row, Index) =>
              <MenuItem key={Index} value={row.idconcepto}>{row.descripcion}</MenuItem>
            )
          }

        </Select>
      </FormControl>
      {
        tipo === 48 ? (

          <AltaPrestamoEm
            lote={lote}
            idempleado={idempleado}
            periodo={periodo}
            notificacion={notificacion}
            idconcepto={tipo}
            obtenerdatolote={obtenerdatolote}
            datotodoempleado={datotodoempleado}

          />
        ) : null
      }


    </>
  )
}

export default AltaDeduccion